var _rect, _line, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    width: 120,
    height: 120,
    role: "img",
    "aria-label": "Analytics icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 112,
    height: 112,
    rx: 14,
    ry: 14,
    fill: "none",
    stroke: "#222",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 96,
    x2: 100,
    y2: 96,
    stroke: "#222",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 78,
    width: 10,
    height: 18,
    rx: 1.5,
    fill: "none",
    stroke: "#222",
    strokeWidth: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 62,
    width: 10,
    height: 34,
    rx: 1.5,
    fill: "none",
    stroke: "#222",
    strokeWidth: 5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 54,
    width: 10,
    height: 42,
    rx: 1.5,
    fill: "none",
    stroke: "#222",
    strokeWidth: 5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 34,
    width: 10,
    height: 62,
    rx: 1.5,
    fill: "none",
    stroke: "#222",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics2);
export default __webpack_public_path__ + "static/media/analytics2.a1a41b911af65f8858317ace2c6daa41.svg";
export { ForwardRef as ReactComponent };